<template lang="html">
    <section class="section-testimonials">
        <div class="row">
            <h2>Our reputations</h2>
        </div>

        <div class="row">
            <div class="col span-1-of-3">
                <blockquote>
                    比如分析基金，从一张指数图，去分析涨跌缘由，学校的课程只是基础知识普及，但若想真正理解，就必须自己去挖每个拐点的原因，分析国际局势、消费者行为。IHD项目中汇丰银行的专业人士的授课，给出了思维模型，让我在往后的接触中不断地填注并修缮模型。引导你去独立分析思考，最终建成自己的理论体系，这是我认为IHD所给予的最有价值的东西。
                    <cite><img src="../../assets/resources/img/dwan_lin.png" alt="Customer 1 photo">Dawn LIN</cite>
                </blockquote>
            </div>
            <div class="col span-1-of-3">
                <blockquote>
                    中午12点，我们倒数第三个出场。台上的我们镇定自若，一串串流利的英语脱口而出。最后，在小组勇夺第二的同时，自己十分意外的收获到了一份实习offer，也为自己的七天之旅画上了一个圆满的句号。我收获了友谊、收获了知识，同时，也在一次次的准备中，使自己的逻辑、条理更加清晰。当然，也又一次的克服了自己怯场、和胆小的毛病，让自己又经历了一次成长！
                    <cite><img src="../../assets/resources/img/mary_ma.png" alt="Customer 2 photo">Mary MA</cite>
                </blockquote>
            </div>
            <div class="col span-1-of-3">
                <blockquote>
                    项目中的每一个Project，都是时限短、强度大。在学校需要一两个星期完成的，在这里只有一两天的时间，然而每个小组都可以完成任务，质量也和平时在学校里做的相当。每次回想起来都会觉得不可思议，同时也需要反思，平时工作效率是否太低，多任务并行下如何高效处理，是IHD教给我的重要一课。
                    <br>
                    <br>
                    <br>
                    <cite><img src="../../assets/resources/img/yin_huang.png" alt="Customer 3 photo">Yin HUANG</cite>
                </blockquote>
            </div>
        </div>
    </section>
</template>

<script>
export default {
}
</script>

<style lang="scss">

.section-testimonials {
    background-image: -webkit-linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(../../assets/resources/img/back-customers.jpg);
    background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(../../assets/resources/img/back-customers.jpg);
    background-size: cover;
    color: #fff;
    background-attachment: fixed;
}

blockquote {
    padding: 2%;
    font-style: italic;
    line-height: 145%;
    position: relative;
    text-align: left;
    margin-top: 40px;

    &:before {
        content: "\201C";
        font-size: 5rem;
        display: block;
        position: absolute;
        top: -5px;
        left: -5px;
    }
}

cite {
    font-size: 0.9rem;
    margin-top: 25px;
    display: block;

    img {
        height: 45px;
        border-radius: 50%;
        margin-right: 10px;
        vertical-align: middle;
    }
}
</style>



// WEBPACK FOOTER //
// Testimonials.vue?37b99724